import { ApiImage } from '../../api/image'
import { BaseImageSorter } from './index'

import _ from 'lodash'

/**
 * 特定のimage_app_kindの画像を先頭に移動する。
 * 該当する画像が見つからない場合は何もしない。
 */
export default class PutImageWithSpecificImageAppKindAtFirst extends BaseImageSorter {
  /**
   * @param imageAppKind 先頭に移動する画像のimage_app_kind
   */
  constructor(private imageAppKind: string) {
    super()
  }

  sort(images: ApiImage[]): ApiImage[] {
    return _.compact( // 指定したimage_app_kindの画像がない場合、partitionが空要素を作成するので、compactで空要素を取り除く。
      _.flatten(
        _.partition(images, (image: ApiImage) => image.imageAppKind === this.imageAppKind)
      )
    )
  }
}
